import React from 'react';
import { GlassCard } from '../shared/GlassCard';
import { GradientText } from '../shared/GradientText';
import { FadeIn, StaggerContainer, StaggerItem } from '../shared/MotionWrapper';

const pillars = [
  {
    icon: '/images/icon-platform.png',
    title: 'PREMIUM DIGITAL PLATFORM',
    subtitle: 'Secured On-Chain Discovery',
    description: 'Built on BSC with enterprise-grade security and transparent smart contracts.',
  },
  {
    icon: '/images/icon-robust.png',
    title: 'ROBUST TECHNICAL FOUNDATION',
    subtitle: 'High-Integrity Blockchain',
    description: 'Immutable ledger technology ensures every draw is verifiable and fair.',
  },
  {
    icon: '/images/icon-secure.png',
    title: 'SECURE & RELIABLE VALUE',
    subtitle: 'Advanced Data Discovery',
    description: 'Your funds and data are protected with multi-layer security protocols.',
  },
  {
    icon: '/images/icon-trust.png',
    title: 'TRUST-BASED ARCHITECTURE',
    subtitle: 'Community Network Expansion',
    description: 'Growing community with neighbor-winning mechanics that reward participation.',
  },
  {
    icon: '/images/icon-branding.png',
    title: 'ADVANCED 3D BRANDING',
    subtitle: 'Multi-Layer Security Protocols',
    description: 'Premium visual identity with cutting-edge design and user experience.',
  },
];

function PillarsSection() {
  return (
    <section className="relative py-24">
      <div className="absolute inset-0 bg-dark" />
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/background-features.jpg)',
          opacity: 0.1,
        }}
      />
      <div className="absolute inset-0 lightning-bg opacity-30" />
      <div className="absolute top-0 left-0 right-0 h-px glow-separator" />

      <div className="container-premium relative z-10">
        <FadeIn className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            <GradientText variant="hash" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Platform</GradientText>{' '}
            <GradientText variant="medora" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Pillars</GradientText>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            The foundation that makes HashMedora the most trusted lottery platform on BSC
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {pillars.slice(0, 4).map((pillar, index) => (
            <StaggerItem key={index}>
              <GlassCard variant="gold" className="p-6 h-full">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <img
                      src={pillar.icon}
                      alt={pillar.title}
                      className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain"
                    />
                  </div>
                  <div>
                    <h3 className="text-hash-gold font-bold text-sm tracking-wide mb-1">
                      {pillar.title}
                    </h3>
                    <p className="text-medora-blue text-xs font-medium mb-2">{pillar.subtitle}</p>
                    <p className="text-gray-400 text-sm leading-relaxed">{pillar.description}</p>
                  </div>
                </div>
              </GlassCard>
            </StaggerItem>
          ))}
        </StaggerContainer>

        <StaggerContainer className="mt-6 flex justify-center">
          {pillars.slice(4).map((pillar, index) => (
            <StaggerItem key={index}>
              <GlassCard variant="gold" className="p-6 w-full max-w-xl">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <img
                      src={pillar.icon}
                      alt={pillar.title}
                      className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain"
                    />
                  </div>
                  <div>
                    <h3 className="text-hash-gold font-bold text-sm tracking-wide mb-1">
                      {pillar.title}
                    </h3>
                    <p className="text-medora-blue text-xs font-medium mb-2">{pillar.subtitle}</p>
                    <p className="text-gray-400 text-sm leading-relaxed">{pillar.description}</p>
                  </div>
                </div>
              </GlassCard>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px glow-separator" />
    </section>
  );
}

export default PillarsSection;
